import { useTranslation } from 'react-i18next';
import { Lang } from '../types';
import { toLang } from '../utils/localized';

/**
 * The active content language, narrowed to the two the data actually has.
 *
 * i18next reports tags like "de-CH" or "en-GB"; the API columns are suffixed
 * `_de` and `_en`. This collapses the two so components don't each repeat
 * `i18n.language.split('-')[0]` and hope the result is a language we ship.
 */
export function useLang(): Lang {
    const { i18n } = useTranslation();
    return toLang(i18n.language);
}

export default useLang;
